/* cs-appointment-prefill · Handoff Contact + Programare v1 (09.09.2026)
   Preselects the native showroom dropdown (name="contact[showroom]") from ?showroom=<code> — only the 4 public codes, only when the
   control is still empty, only on the appointment page's own form. Native value + `change` event; no submit, no lead/analytics event.
   Idempotent (one run per document + on Theme Editor section loads); user/browser-restored choices are never overwritten. */
(function () {
  'use strict';
  if (window.__csAppointmentPrefill) return;
  window.__csAppointmentPrefill = true;
  var ALLOWED = ['bucuresti', 'cluj', 'timisoara', 'constanta'];
  function code() {
    try { var v = new URLSearchParams(location.search).get('showroom'); return v && ALLOWED.indexOf(v) !== -1 ? v : null; } catch (e) { return null; }
  }
  function run() {
    var c = code(); if (!c) return;
    var forms = document.querySelectorAll('form[data-cs-lead-form]');
    for (var i = 0; i < forms.length; i++) {
      var sel = forms[i].querySelector('select[name="contact[showroom]"]');
      if (!sel || sel.dataset.csPrefilled || sel.value) continue;
      var ok = false;
      for (var j = 0; j < sel.options.length; j++) if (sel.options[j].value === c) { ok = true; break; }
      if (!ok) continue;
      sel.value = c; sel.dataset.csPrefilled = '1';
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', function () { run(); });
})();
